import React from 'react';
import styled, { useTheme } from 'styled-components';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { SwipeableDrawer as MuiSwipeableDrawer, Drawer, useMediaQuery } from '@material-ui/core';
import { observer } from 'mobx-react-lite';

import useUI from 'src/hooks/use-ui';
import useViewport from 'src/hooks/use-viewport';
import useCart from 'src/hooks/use-cart';

import { BottomDrawer } from 'src/components/core';
import { CartDropdownV2 } from 'src/components/cart/cart-dropdown-v2';
import { CartDropdown } from 'src/components/cart/cart-dropdown';
import { CartInterstitial } from 'src/components/cart/cart-interstitial';

export const CartDropdownController = observer(
  (): JSX.Element => {
    const flags = useFlags();
    const isCartDropdownV2Enabled = flags['growth.ecomm.cart-v2.rollout'] ?? false;
    const isCartInterstitialEnabled = flags['consumer.ecomm.cart-interstitial.rollout'] ?? false;

    const {
      showCartDrawer,
      showCartInterstitial,
      closeCartInterstitial,
      openCartDrawer,
      closeCartDrawer,
      isIframe,
      iframeHeight,
    } = useUI();
    const { mostRecentItem } = useCart();
    const shouldAnchorInterstitialToBottom = useMediaQuery('(max-width: 439px)');
    const { height, parentOffset } = useViewport();
    const theme = useTheme();

    if (isCartDropdownV2Enabled) {
      return (
        <>
          {isCartInterstitialEnabled &&
            mostRecentItem &&
            (shouldAnchorInterstitialToBottom ? (
              <BottomDrawer
                open={showCartInterstitial}
                onClose={closeCartInterstitial}
                shouldCalculateIframeBottom
                hideExitIcon
                shouldIncludePaperPadding={false}
                shouldUseImportantZIndex={false}
                isIframe={isIframe}
                iframeHeight={iframeHeight}
                viewportHeight={height}
                parentOffset={parentOffset}
              >
                <CartInterstitial />
              </BottomDrawer>
            ) : (
              <Drawer
                anchor='right'
                open={showCartInterstitial}
                onClose={closeCartInterstitial}
                PaperProps={{
                  style: {
                    background: 'none',
                    boxShadow: 'none',
                    overflowY: 'visible',
                  },
                }}
                ModalProps={{
                  BackdropProps: {
                    style: { backgroundColor: theme.colors.whiteOverlay },
                  },
                }}
              >
                <CartInterstitial />
              </Drawer>
            ))}

          <Drawer
            anchor='right'
            open={showCartDrawer}
            onClose={closeCartDrawer}
            PaperProps={{
              style: {
                boxShadow: '-8px 0px 20px 0px #0000001f',
              },
            }}
            ModalProps={{
              BackdropProps: {
                style: { backgroundColor: theme.colors.whiteOverlay },
              },
            }}
          >
            <CartDropdownV2 />
          </Drawer>
        </>
      );
    }

    return (
      <StyledDrawer
        anchor='right'
        open={showCartDrawer}
        onOpen={openCartDrawer}
        onClose={closeCartDrawer}
        disableSwipeToOpen
      >
        <CartDropdown onClose={closeCartDrawer} />
      </StyledDrawer>
    );
  }
);

const StyledDrawer = styled(MuiSwipeableDrawer)`
  .MuiBackdrop-root {
    background-color: ${({ theme }) => theme.colors.whiteOverlay};
  }
`;
